module.exports = __webpack_public_path__ + "img/prepended-line.81d2e646.svg";